// src/form-component/FormInputDropdown.tsx

import { Checkbox, FormControl, InputLabel, ListItemText, ListSubheader, MenuItem, OutlinedInput, Select, SelectChangeEvent } from '@mui/material';
import { ReactNode, useCallback, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

const StyledCheckbox = styled(Checkbox)({
  paddingLeft: '0!important',
});

interface IOption {
  isLabel?: boolean;
  value: any;
  label: ReactNode;
}

interface IProps {
  multiple?: boolean;
  disabled?: boolean;
  options: IOption[];
  defaultValue?: any;
  onChange?: (value: string[]) => void;
  onOpenSelect?: () => void;
}

export const FieldResolutionStatus = ({ options, defaultValue = null, multiple = true, onChange = null, onOpenSelect, disabled }: IProps) => {
  const [value, setValue] = useState<string[]>(defaultValue || []);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const ValueRender = useCallback(
    (value: string | string[]) => {
      if (multiple && Array.isArray(value)) {
        const selected = value.map((v) => options?.find((option) => option.value === v)?.label);
        return <span className='capitalize'>{selected.join(', ')}</span>;
      }
      const selected = options?.find((option) => option.value === value)?.label;
      return <span className='capitalize'>{selected}</span>;
    },
    [multiple, options]
  );

  return (
    <FormControl size='small'>
      <InputLabel>Resolution Status</InputLabel>
      <Select
        id='field-resolution-status'
        name='resolution_status'
        onChange={(event: SelectChangeEvent<string[]>) => {
          const newValue = Array.isArray(event.target.value) ? event.target.value : [event.target.value];
          setValue(newValue);
          onChange(newValue);
        }}
        value={value}
        multiple={multiple}
        input={<OutlinedInput label='Resolution Status' />}
        renderValue={ValueRender}
        onOpen={onOpenSelect}
        disabled={disabled}
      >
        {options?.map((option) => {
          if (option?.isLabel) {
            return <ListSubheader key={option.value}>{option.label}</ListSubheader>;
          }
          return (
            <MenuItem key={option.value} value={option.value}>
              {multiple && <StyledCheckbox checked={!!value?.find((v) => v === option.value)} />}
              <ListItemText primary={option.label} sx={{ textTransform: 'capitalize' }} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
